var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 10.7498V14.2498C13.3307 17.1665 12.1641 18.3332 9.2474 18.3332H5.7474C2.83073 18.3332 1.66406 17.1665 1.66406 14.2498V10.7498C1.66406 7.83317 2.83073 6.6665 5.7474 6.6665H9.2474C12.1641 6.6665 13.3307 7.83317 13.3307 10.7498Z",
    stroke: "#d4d4d4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 5.74984V9.24984C18.3307 12.1665 17.1641 13.3332 14.2474 13.3332H13.3307V10.7498C13.3307 7.83317 12.1641 6.6665 9.2474 6.6665H6.66406V5.74984C6.66406 2.83317 7.83073 1.6665 10.7474 1.6665H14.2474C17.1641 1.6665 18.3307 2.83317 18.3307 5.74984Z",
    stroke: "#d4d4d4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.a2b6ddbbd3b509ffd7937a012f87fcc5.svg";
export { ForwardRef as ReactComponent };